//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import Group from "./Group.vue";
import Item from "./Item.vue";
import { debounce } from "debounce";

export default {
  name: "BlueFilters",
  components: { Group, Item }, data() {
    return {
      mobileDrawerOpen: false,
    };
  },
  computed: {
		...mapGetters([
			"siteName"
		]),
    filters() {
      if (this.config.showZeroResultFilters) {
        return this.$store.getters.filters;
      }
      return this.$store.getters.filters.filter((g) =>
        g.visible ? true : g.filters.some((f) => f.selected)
      );
    },
    extended() {
      return this.$store.getters.extended;
    },
  },
  methods: {
    clearAllFilters() {
      this.$store.dispatch("removeAllTags");
    },
    toggleMobileDrawer(toggle = !this.mobileDrawerOpen) {
      this.mobileDrawerOpen = toggle;
			const header = document.querySelector("header.header");
			if (!!header && this.siteName == "ORG") {
				if (toggle) {
					header.style.zIndex= "1";
				} else {
					header.style.zIndex= "";
				}
			}
    },
    setFilterValue(filter, val, callback) {
      let value;
      if (typeof val === "object") value = val.target.value;
      else value = val;
      this.$store.commit("setFilterValue", { filter, value });
      if (this.config.filterAutoSubmit) return this.executeSearch(callback);
    },
    extend(callback) {
      this.$store.commit("extend", callback);
    },
		executeSearch: debounce(function (callback) {
				if (this.config.preserveResults) this.$store.commit("clearPreviousItemResults");
				return this.$store.dispatch("executeSearch", callback);
			}, 50)
  },
};
